// ============================================================================
// LES SEGMENTS RFM, NOMMÉS — ce que l'écran affiche d'un segment que le cœur a calculé (`core-analytics`, `rfmSegment`).
// Partagé par le ciblage des campagnes et Statistiques › Clients : deux tables du même nom divergeraient.
//
// ⚠️ LA VALEUR VOYAGE TELLE QUE LE SERVEUR LA NOMME : un segment absent d'ici s'affiche tel quel plutôt que de disparaître.
// ⚠️ LA DESCRIPTION DIT LA RÈGLE DU CŒUR (récence, fréquence, montant par quintiles), pas une impression : la changer
//    là-bas oblige à la relire ici.
// ============================================================================
import { key, t, type DeclaredKey } from './i18n';
import type { Tone } from './screens/stats-resume';

export const RFM_SEGMENT_LABELS: Record<string, DeclaredKey> = {
  champions: key('Champions'), 'fidèles': key('Fidèles'), 'réguliers': key('Réguliers'),
  nouveaux: key('Nouveaux'), 'à risque': key('À risque'), perdus: key('Perdus'),
};

/** Ce que veut dire chaque segment, dans les termes de la règle du cœur. */
const RFM_SEGMENT_HINTS: Record<string, DeclaredKey> = {
  champions: key('Récents, fréquents et gros acheteurs'),
  'à risque': key('Venaient souvent, ne reviennent plus'),
  'fidèles': key('Viennent souvent'),
  nouveaux: key('Récents, encore peu de visites'),
  perdus: key('Ni récents, ni fréquents'),
  'réguliers': key('Entre les deux'),
};

/** La teinte d'un segment — de la meilleure valeur à la plus faible. */
export const RFM_SEGMENT_TONES: Record<string, Tone> = {
  champions: 'teal', 'fidèles': 'violet', 'réguliers': 'blue', nouveaux: 'amber', 'à risque': 'rose', perdus: 'rose',
};

/** Le nom d'un segment, dans la langue du compte. */
export const rfmSegmentLabel = (segment: string): string => (RFM_SEGMENT_LABELS[segment] ? t(RFM_SEGMENT_LABELS[segment]!) : segment);
/** Sa description, ou rien pour un segment que l'écran ne connaît pas. */
export const rfmSegmentHint = (segment: string): string => (RFM_SEGMENT_HINTS[segment] ? t(RFM_SEGMENT_HINTS[segment]!) : '');
